import React from "react";
import { ENV, buildStorageUrl } from "../../../utils";
import Dropzone from "react-dropzone";
import ReactAudioPlayer from "react-audio-player";

export function AudioUploader(props) {
  const { audio, setAudio } = props;

  const onDrop = (acceptedFile) => {
    setAudio(
      Object.assign(acceptedFile[0], {
        preview: URL.createObjectURL(acceptedFile[0]),
      })
    );
  };

  return (
    <div className="media-slide__input-audio">
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps }) => (
          <div
            className="media-slide__input-audio_drop-zone"
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <p>Selecciona o arrastra tu archivo de audio</p>
          </div>
        )}
      </Dropzone>
      {audio && (
        <ReactAudioPlayer
          src={
            audio?.preview?.startsWith("blob:")
              ? audio?.preview
              : buildStorageUrl(audio?.preview) || audio?.preview
          }
          controls
        />
      )}
    </div>
  );
}
